import { VueModule } from '@Foundation/utilities';
import StarData from './code/Scripts/components/star-data';

export default VueModule({
  components: {
    StarData
  }
});
